// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and Base Styles */

/* Reset and Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.nature-mission-page {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

/* Hero Section */
.hero {
  position: relative;
  min-height: 0vh;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: hidden;
  padding-bottom: 0;
}

.parallax-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('https://res.cloudinary.com/dy8shu8ss/image/upload/v1740000000/nature-bg.jpg') no-repeat center;
  background-size: cover;
  z-index: -1;
  opacity: 0.3;
}

.video-container {
  position: relative;
  width: 100%;
  max-width: 1600px;
  padding-bottom: 0;
  margin: 0 auto;
}

.hero-video {
  width: 100%;
  height: auto;
  object-fit: cover;
  max-height: 90vh;
  display: block;
}

.video-caption {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  margin: 0px;
  padding: 5px 10px;
  border-radius: 3px;
  font-size: clamp(0.9rem, 2vw, 1.5rem);
}

.video-dots {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}

.dot {
  width: 10px;
  height: 10px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.3s;
}

.dot.active {
  background: white;
}

.hero-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
}

.hero-content h1 {
  font-size: clamp(2.5rem, 5vw, 2rem);
  margin-bottom: 1rem;
}

.hero-content p {
  font-size: clamp(1rem, 3vw, 1.5rem);
  margin-bottom: 1.5rem;
}

.cta-button {
  display: inline-block;
  padding: 0.8rem 1.5rem;
  background: #28a745;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  font-size: clamp(0.9rem, 2vw, 1.2rem);
  margin: 0.5rem;
  border: none;
  cursor: pointer;
  transition: background 0.3s;
}

.cta-button:hover {
  background: #218838;
}

.cta-button.secondary {
  background: #007bff;
}

.cta-button.secondary:hover {
  background: #0056b3;
}

/* Navigation */
.sticky-nav {
  position: sticky;
  top: 0;
  background: rgba(255, 255, 255, 0.9);
  padding: 0.5rem;
  margin-top: 0;
  text-align: center;
  z-index: 10;
}

.sticky-nav a {
  margin: 0 1rem;
  text-decoration: none;
  color: #333;
  font-weight: bold;
  font-size: clamp(0.9rem, 2vw, 1.1rem);
}

/* General Section Styling */
.initiatives, .progress, .testimonials, .articles, .get-involved {
  padding: 3rem 1rem;
  text-align: center;
}

.initiatives h2, .progress h2, .testimonials h2, .articles h2, .get-involved h2 {
  font-size: clamp(1.5rem, 4vw, 2.5rem);
  margin-bottom: 2rem;
  margin-top: 2rem;
  color: #333;
  text-align: center;
}

/* Grid Layouts */
.initiative-grid, .progress-grid, .testimonial-grid, .article-grid, .get-involved-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

/* Initiative Cards */
.initiative-card {
  background: white;
  padding: 1rem;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
}

.initiative-card:hover {
  transform: translateY(-5px);
}

.initiative-card img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 5px;
  margin-bottom: 15px;
}

.initiative-card h3 {
  font-size: 1.5rem;
  color: #4CAF50;
  margin-bottom: 10px;
}

.initiative-card p {
  font-size: 1rem;
  color: #666;
}

/* Progress Cards */
.progress-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.progress-card h3 {
  font-size: 2rem;
  color: #4CAF50;
  margin-bottom: 10px;
}

.progress-card p {
  font-size: 1rem;
  color: #666;
}

/* Testimonials */
.testimonials {
  background-color: #f9f9f9;
}

.testimonial-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.testimonial-card p {
  font-size: 1.1rem;
  color: #666;
  font-style: italic;
}

/* Articles Section */
.articles {
  background-color: #f9f9f9;
}

.article-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  text-align: left;
}

.article-card h3 {
  font-size: 1.5rem;
  color: #4CAF50;
  margin-bottom: 15px;
}

.article-card p {
  font-size: 1rem;
  color: #666;
  margin-bottom: 15px;
}

.article-card ol {
  padding-left: 20px;
  margin-bottom: 15px;
}

.article-card ol li {
  font-size: 1rem;
  color: #666;
  margin-bottom: 10px;
}

.article-card button {
  padding: 10px 20px;
  background: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s;
}

.article-card button:hover {
  background: #45a049;
}

.try-it-form {
  margin-top: 20px;
  padding: 15px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.try-it-form h4 {
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 15px;
}

.try-it-form input,
.try-it-form textarea {
  display: block;
  width: 100%;
  margin: 10px 0;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.try-it-form textarea {
  resize: vertical;
}

.image-preview {
  max-width: 100%;
  height: auto;
  margin: 10px 0;
  border-radius: 5px;
}

.try-it-form button {
  padding: 8px 16px;
  margin-right: 10px;
  background: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s;
}

.try-it-form button[type="button"] {
  background: #ccc;
}

.try-it-form button:hover {
  background: #45a049;
}

.try-it-form button[type="button"]:hover {
  background: #bbb;
}

/* Carousel Section */
.submissions {
  height: 100%;
  margin: 0 auto;
  padding: 20px 0;
  
}

.submissions h4 {
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 15px;
}

.submission-item {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  background-color: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
  padding: 10px;

}

.submission-item .image-container {
  width: 60%;
  height: 400%;
  display: flex;
  align-items: center;
  justify-content: center;
  
}

.submission-image {
  max-width: 100%;
  max-height: 380px;
  height: 500%;
  object-fit: contain;
  object-position: center;
  
}

.submission-item .description-container {
  flex: 0 0 40%; /* Take exactly 40% of the width */
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  background-color: #e0e0e0; /* Add background color for debugging */
  overflow-y: auto;
  /* Allow scrolling if text overflows */
}

.submission-item .description-container p {
  margin: 0;
  font-size: 14px;
  color: #333;
  max-height: 100%;
  height: 100%;
  overflow-y: auto;
  
  text-align: left;
  width: 100%;
}

.slick-slider, .slick-list, .slick-track {
  height: 400px !important;
}

.slick-dots li button:before {
  font-size: 12px;
  color: #888;
}

.slick-dots li.slick-active button:before {
  color: #333;
}

.slick-prev, .slick-next {
  z-index: 1;
}

.slick-prev:before, .slick-next:before {
  color: #333;
  font-size: 24px;
}

/* Get Involved Section */
.get-involved-grid .card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.card h3 {
  font-size: 1.5rem;
  color: #4CAF50;
  margin-bottom: 15px;
}

.card p {
  font-size: 1rem;
  color: #666;
  margin-bottom: 15px;
}

.card form {
  text-align: left;
}

.card input,
.card textarea {
  display: block;
  width: 100%;
  margin: 10px 0;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.card textarea {
  resize: vertical;
}

.card button {
  padding: 10px 20px;
  background: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s;
}

.card button:hover {
  background: #45a049;
}

/* Footer */
.footer {
  background: #333;
  color: white;
  padding: 40px 20px;
  text-align: center;
}

.footer-content {
  display: flex;
  justify-content: space-around;
  max-width: 1200px;
  margin: 0 auto;
  flex-wrap: wrap;
}

.footer-content div {
  margin: 10px;
}

.footer-content h3 {
  font-size: 1.5rem;
  margin-bottom: 15px;
}

.footer-content p {
  font-size: 1rem;
}

.social-links {
  margin-top: 10px;
}

.social-links a {
  color: #4CAF50;
  text-decoration: none;
  margin: 0 10px;
  transition: color 0.3s;
}

.social-links a:hover {
  color: #45a049;
}
.info-icon {
  margin-left: 5px;
  font-size: 14px;
  vertical-align: middle;
  cursor: pointer;
}

.info-icon:hover {
  color: #007bff; 
}




.video-dots {
  display: none !important;
}

/* Hide hero video caption on mobile screens */
@media (max-width: 768px) {
  .video-caption {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NatureMissionPage.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+GAA+G;EAC/G,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,MAAM;EACN,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,cAAc;EACd,eAAe;;AAEjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;;AAEf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;AAEzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;;AAEzB;;AAEA;EACE,aAAa,EAAE,kCAAkC;EACjD,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,yBAAyB,EAAE,uCAAuC;EAClE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;;EAEhB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;;;;AAKA;EACE,wBAAwB;AAC1B;;AAEA,8CAA8C;AAC9C;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Reset and Base Styles */\n\n/* Reset and Base Styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.nature-mission-page {\n  font-family: Arial, sans-serif;\n  line-height: 1.6;\n  color: #333;\n}\n\n/* Hero Section */\n.hero {\n  position: relative;\n  min-height: 0vh;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  overflow: hidden;\n  padding-bottom: 0;\n}\n\n.parallax-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: url('https://res.cloudinary.com/dy8shu8ss/image/upload/v1740000000/nature-bg.jpg') no-repeat center;\n  background-size: cover;\n  z-index: -1;\n  opacity: 0.3;\n}\n\n.video-container {\n  position: relative;\n  width: 100%;\n  max-width: 1600px;\n  padding-bottom: 0;\n  margin: 0 auto;\n}\n\n.hero-video {\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n  max-height: 90vh;\n  display: block;\n}\n\n.video-caption {\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  margin: 0px;\n  padding: 5px 10px;\n  border-radius: 3px;\n  font-size: clamp(0.9rem, 2vw, 1.5rem);\n}\n\n.video-dots {\n  position: absolute;\n  bottom: 30px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 10px;\n}\n\n.dot {\n  width: 10px;\n  height: 10px;\n  background: rgba(255, 255, 255, 0.5);\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.dot.active {\n  background: white;\n}\n\n.hero-content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);\n}\n\n.hero-content h1 {\n  font-size: clamp(2.5rem, 5vw, 2rem);\n  margin-bottom: 1rem;\n}\n\n.hero-content p {\n  font-size: clamp(1rem, 3vw, 1.5rem);\n  margin-bottom: 1.5rem;\n}\n\n.cta-button {\n  display: inline-block;\n  padding: 0.8rem 1.5rem;\n  background: #28a745;\n  color: white;\n  text-decoration: none;\n  border-radius: 5px;\n  font-size: clamp(0.9rem, 2vw, 1.2rem);\n  margin: 0.5rem;\n  border: none;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.cta-button:hover {\n  background: #218838;\n}\n\n.cta-button.secondary {\n  background: #007bff;\n}\n\n.cta-button.secondary:hover {\n  background: #0056b3;\n}\n\n/* Navigation */\n.sticky-nav {\n  position: sticky;\n  top: 0;\n  background: rgba(255, 255, 255, 0.9);\n  padding: 0.5rem;\n  margin-top: 0;\n  text-align: center;\n  z-index: 10;\n}\n\n.sticky-nav a {\n  margin: 0 1rem;\n  text-decoration: none;\n  color: #333;\n  font-weight: bold;\n  font-size: clamp(0.9rem, 2vw, 1.1rem);\n}\n\n/* General Section Styling */\n.initiatives, .progress, .testimonials, .articles, .get-involved {\n  padding: 3rem 1rem;\n  text-align: center;\n}\n\n.initiatives h2, .progress h2, .testimonials h2, .articles h2, .get-involved h2 {\n  font-size: clamp(1.5rem, 4vw, 2.5rem);\n  margin-bottom: 2rem;\n  margin-top: 2rem;\n  color: #333;\n  text-align: center;\n}\n\n/* Grid Layouts */\n.initiative-grid, .progress-grid, .testimonial-grid, .article-grid, .get-involved-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Initiative Cards */\n.initiative-card {\n  background: white;\n  padding: 1rem;\n  border-radius: 5px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s;\n}\n\n.initiative-card:hover {\n  transform: translateY(-5px);\n}\n\n.initiative-card img {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n  border-radius: 5px;\n  margin-bottom: 15px;\n}\n\n.initiative-card h3 {\n  font-size: 1.5rem;\n  color: #4CAF50;\n  margin-bottom: 10px;\n}\n\n.initiative-card p {\n  font-size: 1rem;\n  color: #666;\n}\n\n/* Progress Cards */\n.progress-card {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.progress-card h3 {\n  font-size: 2rem;\n  color: #4CAF50;\n  margin-bottom: 10px;\n}\n\n.progress-card p {\n  font-size: 1rem;\n  color: #666;\n}\n\n/* Testimonials */\n.testimonials {\n  background-color: #f9f9f9;\n}\n\n.testimonial-card {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.testimonial-card p {\n  font-size: 1.1rem;\n  color: #666;\n  font-style: italic;\n}\n\n/* Articles Section */\n.articles {\n  background-color: #f9f9f9;\n}\n\n.article-card {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  text-align: left;\n}\n\n.article-card h3 {\n  font-size: 1.5rem;\n  color: #4CAF50;\n  margin-bottom: 15px;\n}\n\n.article-card p {\n  font-size: 1rem;\n  color: #666;\n  margin-bottom: 15px;\n}\n\n.article-card ol {\n  padding-left: 20px;\n  margin-bottom: 15px;\n}\n\n.article-card ol li {\n  font-size: 1rem;\n  color: #666;\n  margin-bottom: 10px;\n}\n\n.article-card button {\n  padding: 10px 20px;\n  background: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.article-card button:hover {\n  background: #45a049;\n}\n\n.try-it-form {\n  margin-top: 20px;\n  padding: 15px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.try-it-form h4 {\n  font-size: 1.2rem;\n  color: #333;\n  margin-bottom: 15px;\n}\n\n.try-it-form input,\n.try-it-form textarea {\n  display: block;\n  width: 100%;\n  margin: 10px 0;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n}\n\n.try-it-form textarea {\n  resize: vertical;\n}\n\n.image-preview {\n  max-width: 100%;\n  height: auto;\n  margin: 10px 0;\n  border-radius: 5px;\n}\n\n.try-it-form button {\n  padding: 8px 16px;\n  margin-right: 10px;\n  background: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.try-it-form button[type=\"button\"] {\n  background: #ccc;\n}\n\n.try-it-form button:hover {\n  background: #45a049;\n}\n\n.try-it-form button[type=\"button\"]:hover {\n  background: #bbb;\n}\n\n/* Carousel Section */\n.submissions {\n  height: 100%;\n  margin: 0 auto;\n  padding: 20px 0;\n  \n}\n\n.submissions h4 {\n  font-size: 1.2rem;\n  color: #333;\n  margin-bottom: 15px;\n}\n\n.submission-item {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-between;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  overflow: hidden;\n  padding: 10px;\n\n}\n\n.submission-item .image-container {\n  width: 60%;\n  height: 400%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n}\n\n.submission-image {\n  max-width: 100%;\n  max-height: 380px;\n  height: 500%;\n  object-fit: contain;\n  object-position: center;\n  \n}\n\n.submission-item .description-container {\n  flex: 0 0 40%; /* Take exactly 40% of the width */\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 10px;\n  background-color: #e0e0e0; /* Add background color for debugging */\n  overflow-y: auto;\n  /* Allow scrolling if text overflows */\n}\n\n.submission-item .description-container p {\n  margin: 0;\n  font-size: 14px;\n  color: #333;\n  max-height: 100%;\n  height: 100%;\n  overflow-y: auto;\n  \n  text-align: left;\n  width: 100%;\n}\n\n.slick-slider, .slick-list, .slick-track {\n  height: 400px !important;\n}\n\n.slick-dots li button:before {\n  font-size: 12px;\n  color: #888;\n}\n\n.slick-dots li.slick-active button:before {\n  color: #333;\n}\n\n.slick-prev, .slick-next {\n  z-index: 1;\n}\n\n.slick-prev:before, .slick-next:before {\n  color: #333;\n  font-size: 24px;\n}\n\n/* Get Involved Section */\n.get-involved-grid .card {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.card h3 {\n  font-size: 1.5rem;\n  color: #4CAF50;\n  margin-bottom: 15px;\n}\n\n.card p {\n  font-size: 1rem;\n  color: #666;\n  margin-bottom: 15px;\n}\n\n.card form {\n  text-align: left;\n}\n\n.card input,\n.card textarea {\n  display: block;\n  width: 100%;\n  margin: 10px 0;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n}\n\n.card textarea {\n  resize: vertical;\n}\n\n.card button {\n  padding: 10px 20px;\n  background: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.card button:hover {\n  background: #45a049;\n}\n\n/* Footer */\n.footer {\n  background: #333;\n  color: white;\n  padding: 40px 20px;\n  text-align: center;\n}\n\n.footer-content {\n  display: flex;\n  justify-content: space-around;\n  max-width: 1200px;\n  margin: 0 auto;\n  flex-wrap: wrap;\n}\n\n.footer-content div {\n  margin: 10px;\n}\n\n.footer-content h3 {\n  font-size: 1.5rem;\n  margin-bottom: 15px;\n}\n\n.footer-content p {\n  font-size: 1rem;\n}\n\n.social-links {\n  margin-top: 10px;\n}\n\n.social-links a {\n  color: #4CAF50;\n  text-decoration: none;\n  margin: 0 10px;\n  transition: color 0.3s;\n}\n\n.social-links a:hover {\n  color: #45a049;\n}\n.info-icon {\n  margin-left: 5px;\n  font-size: 14px;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.info-icon:hover {\n  color: #007bff; \n}\n\n\n\n\n.video-dots {\n  display: none !important;\n}\n\n/* Hide hero video caption on mobile screens */\n@media (max-width: 768px) {\n  .video-caption {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
